import styled from 'styled-components';


export const StyledMember = styled.div`
	form.member-form {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		padding-top: 10px;

		.w-half {
			width: calc(50% - 10px);
			margin-top: -10px;
		}
		& > div {
			margin-top: 10px;
		}
	}

	.overflow-layout {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 90;
		background: #FFFFFF50;
	}
	
	label {
		min-height: 16px;
		color: #333336;
		font-size: 13px;
		font-weight: 500;
	}

	.radioSection {
		margin-top: 15px !important;

		& + & {
			margin-top: 20px !important;
		}
		& > label {
			margin-bottom: 10px;
			display: block;
		}
		.radio {
			margin-top: 5px;
		}
	}
`;
